module.exports = __webpack_public_path__ + "img/currentLocationMarker.6294e555.png";